'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reactRedux = require('react-redux');

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _warning = require('warning');

var _warning2 = _interopRequireDefault(_warning);

var _IntlProvider = require('./IntlProvider');

var _IntlProvider2 = _interopRequireDefault(_IntlProvider);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Provider = function Provider(_ref) {
  var store = _ref.store;
  var children = _ref.children;

  return _react2.default.createElement(
    _reactRedux.Provider,
    { store: store },
    _react2.default.createElement(
      _IntlProvider2.default,
      null,
      children
    )
  );
};

Provider.propTypes = {
  children: _react.PropTypes.element.isRequired,
  store: _react.PropTypes.object.isRequired
};

exports.default = Provider;


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-intl-redux/lib/components/Provider.js
 ** module id = 1234
 ** module chunks = 1
 **/